import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../config/analytics';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on page change
    window.scrollTo(0, 0);
    
    // Track page view in Google Analytics
    trackPageView(pathname);
  }, [pathname]);

  return null; // This component does not render anything
};

export default ScrollToTop; 